'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwitterIcon = function (_React$Component) {
    _inherits(TwitterIcon, _React$Component);

    function TwitterIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TwitterIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TwitterIcon.__proto__ || Object.getPrototypeOf(TwitterIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 43.258 43.258' },
                _react2.default.createElement(
                    'g',
                    { id: 'twitter_pink', 'data-name': 'twitter pink', transform: 'translate(-248.657 -629.365)', fill: 'transparent' },
                    _react2.default.createElement('path', { id: 'Path_3630', 'data-name': 'Path 3630', d: 'M299.049,651a21.629,21.629,0,1,1-21.629-21.629A21.629,21.629,0,0,1,299.049,651Zm-26.344,10.327a14.734,14.734,0,0,0,14.835-14.835q0-.34-.015-.674a10.59,10.59,0,0,0,2.6-2.7,10.377,10.377,0,0,1-2.994.82,5.23,5.23,0,0,0,2.293-2.884,10.438,10.438,0,0,1-3.311,1.266,5.218,5.218,0,0,0-8.886,4.755,14.8,14.8,0,0,1-10.747-5.447,5.218,5.218,0,0,0,1.614,6.961,5.172,5.172,0,0,1-2.361-.652c0,.021,0,.043,0,.066a5.216,5.216,0,0,0,4.183,5.111,5.182,5.182,0,0,1-2.354.09,5.218,5.218,0,0,0,4.871,3.621,10.55,10.55,0,0,1-7.719,2.16,14.761,14.761,0,0,0,7.992,2.342', transform: 'translate(-7.134 -0.002)', fill: primary })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TwitterIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 48;
            return _react2.default.createElement(
                _layout2.default,
                { size: size },
                this.getIcon(size, size, this.props.color)
            );
        }
    }]);

    return TwitterIcon;
}(_react2.default.Component);

exports.default = TwitterIcon;